import React from 'react';
import { FaFileDownload, FaSpinner, FaFileExcel } from 'react-icons/fa';

const ExportSection = ({ 
    onExportThis, 
    onStartOver,
    isExporting, 
    transactions = [],
    fileCount = 1
}) => {
    const enabledCount = transactions.filter(tx => tx.enabled !== false).length;
    const isMulti = fileCount > 1;

    return (
        <div className="stage3-export-bar">
            <div>
                <h6 className="fw-bold text-dark m-0">Stage 3: Export Final Statement</h6>
                <p className="text-muted small m-0 mt-1">
                    Only the <strong className="text-dark">{enabledCount} enabled</strong> transactions will be included in the exported file.
                </p>
            </div>
            <div className="d-flex gap-2 align-items-center">
                {onStartOver && (
                    <button 
                        className="btn-pill-startover" 
                        onClick={onStartOver}
                    >
                        Start Over
                    </button>
                )}
                <button 
                    className="btn-pill-export-green" 
                    onClick={onExportThis}
                    disabled={isExporting || enabledCount === 0}
                >
                    {isExporting ? <FaSpinner className="fa-spin" /> : (isMulti ? <FaFileExcel size={16} /> : <FaFileDownload size={16} />)}
                    {isExporting ? 'Generating...' : (isMulti ? 'Export All Statements (.xlsx)' : 'Download Excel Sheet')}
                </button>
            </div>
        </div>
    );
};

export default ExportSection;